function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.83 11.32a.556.556 0 01-.821 0L8 5.99 2.991 11.32a.556.556 0 01-.82 0 .646.646 0 010-.873L7.588 4.68a.556.556 0 01.822 0l5.419 5.765a.646.646 0 010 .873z",
  fill: "#2D2D2D"
});
function SvgChevronarriba(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Chevron arriba.svg";
export { SvgChevronarriba as ReactComponent };